var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-redeclare, no-var, object-curly-spacing, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");

var GraphSettings = require("../components/graph-settings.jsx");
var InfoTip = require("../components/info-tip.jsx");
var MultiButtonGroup = require("react-components/multi-button-group.jsx");

var Grapher = require("./grapher.jsx").widget;

var _require = require("./grapher/util.jsx"),
    GrapherUtil = _require.GrapherUtil,
    allTypes = _require.allTypes,
    typeToButton = _require.typeToButton,
    DEFAULT_GRAPHER_PROPS = _require.DEFAULT_GRAPHER_PROPS;

var _require2 = require("../util/sizing-utils.js"),
    containerSizeClass = _require2.containerSizeClass,
    getInteractiveBoxFromSizeClass = _require2.getInteractiveBoxFromSizeClass;

var GrapherEditor = React.createClass({
    displayName: "GrapherEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            correct: DEFAULT_GRAPHER_PROPS.plot,
            graph: DEFAULT_GRAPHER_PROPS.graph,
            availableTypes: DEFAULT_GRAPHER_PROPS.availableTypes
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var _this = this;

        var sizeClass = containerSizeClass.SMALL;
        var equationString = void 0;
        var graph = void 0;
        if (this.props.graph.valid === true) {
            var graphProps = {
                graph: this.props.graph,
                plot: this.props.correct,
                availableTypes: this.props.availableTypes,
                onChange: function onChange(newProps, cb) {
                    var correct = _this.props.correct;
                    if (correct.type === newProps.plot.type) {
                        correct = _.extend({}, correct, newProps.plot);
                    } else {
                        // Clear options from previous graph
                        correct = newProps.plot;
                    }
                    _this.props.onChange({ correct: correct }, cb);
                },
                trackInteraction: function trackInteraction() {}
            };

            graph = React.createElement(Grapher, _extends({}, graphProps, {
                apiOptions: this.props.apiOptions,
                containerSizeClass: sizeClass
            }));
            equationString = GrapherUtil.getEquationString(graphProps);
        } else {
            graph = React.createElement(
                "div",
                { className: "perseus-error" },
                this.props.graph.valid
            );
        }

        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                "Correct answer",
                " ",
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Graph the correct answer in the graph below and ensure the equation or point coordinates displayed represent the correct answer."
                    )
                ),
                " ",
                ": ",
                equationString
            ),
            React.createElement(GraphSettings, {
                editableSettings: ["graph", "snap", "image"],
                box: getInteractiveBoxFromSizeClass(sizeClass),
                range: this.props.graph.range,
                labels: this.props.graph.labels,
                step: this.props.graph.step,
                gridStep: this.props.graph.gridStep,
                snapStep: this.props.graph.snapStep,
                valid: this.props.graph.valid,
                backgroundImage: this.props.graph.backgroundImage,
                markings: this.props.graph.markings,
                rulerLabel: this.props.graph.rulerLabel,
                rulerTicks: this.props.graph.rulerTicks,
                showTooltips: this.props.graph.showTooltips,
                onChange: this.change("graph")
            }),
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "label",
                    null,
                    "Available functions:  "
                ),
                React.createElement(MultiButtonGroup, {
                    allowEmpty: false,
                    values: this.props.availableTypes,
                    buttons: _.map(allTypes, typeToButton),
                    onChange: this.handleAvailableTypesChange
                })
            ),
            graph
        );
    },

    handleAvailableTypesChange: function handleAvailableTypesChange(newAvailableTypes) {
        var correct = this.props.correct;

        // If the currently 'correct' type is removed from the list of types,
        // we need to change it to avoid impossible questions.
        if (!_.contains(newAvailableTypes, this.props.correct.type)) {
            var graph = this.props.graph;
            var newType = GrapherUtil.chooseType(newAvailableTypes);
            var correct = GrapherUtil.defaultPlotProps(newType, graph);
        }
        this.props.onChange({
            availableTypes: newAvailableTypes,
            correct: correct
        });
    },

    serialize: function serialize() {
        return _.chain(this.props).pick("correct", "availableTypes").extend({ graph: _.omit(this.props.graph, "box") }).value();
    }
});

module.exports = GrapherEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/grapher-editor.jsx
 ** module id = 105
 ** module chunks = 0 1
 **/